// Owner-only tools for the /admin page. Reports, removals and suspensions can
// only be read by the owner (database.rules.json), and every change goes
// through a callable Cloud Function that checks ADMIN_UIDS again on the server.

import { getFunctions, httpsCallable } from 'firebase/functions';
import { getDatabase, ref as dbRef, update, get, query, orderByChild, equalTo } from 'firebase/database';
import { getStorage, ref as fileRef, uploadBytes, getDownloadURL } from 'firebase/storage';

/** Keep in step with ADMIN_UIDS in functions/index.js. Only hides the link and page. */
export const ADMIN_UIDS = ['oya3DMuWLdS1blp4SQn7WtciMtT2'];

export const isAdmin = uid => ADMIN_UIDS.includes(uid);

const call = (name, data) => httpsCallable(getFunctions(), name)(data);

export const removePost = (node, id, reason) => call('adminRemovePost', { node, id, reason });
export const removePhoto = uid => call('adminRemovePhoto', { uid });
export const setSuspended = (uid, suspended, reason) => call('adminSetSuspended', { uid, suspended, reason });
export const resolveReport = id => call('adminResolveReport', { id });
export const postSponsoredRide = ride => call('adminPostSponsoredRide', ride);

/** Saves sponsor settings to config/sponsor; empty text clears a setting. */
export function saveSponsor(values) {
  const clean = Object.fromEntries(Object.entries(values).map(([k, v]) =>
    [k, typeof v === 'string' ? (v.trim() || null) : v]));
  return update(dbRef(getDatabase(), 'config/sponsor'), clean);
}

/** Uploads a sponsor image and returns its public URL. */
export async function uploadSponsorImage(file) {
  const name = `${Date.now()}-${file.name.replace(/[^a-z0-9.]+/gi, '-').toLowerCase()}`;
  const target = fileRef(getStorage(), `sponsors/${name}`);
  await uploadBytes(target, file, { contentType: file.type });
  return getDownloadURL(target);
}

/** A user by exact username, as { uid, name, username, car }, or null. */
export async function findDriver(username) {
  const name = username.trim().replace(/^@/, '');
  if (!name) return null;
  const snap = await get(query(dbRef(getDatabase(), 'users'), orderByChild('username'), equalTo(name)));
  const [uid, user] = Object.entries(snap.val() || {})[0] || [];
  return uid ? { uid, ...user } : null;
}
